import { cn } from 'lib/utils';

/** A top-bar destination. The current one is an ink pill; the rest stay quiet. */
export function portalNavLinkClass(active: boolean): string {
  return cn(
    'inline-flex h-10 items-center gap-1 whitespace-nowrap rounded-[10px] px-3.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
    active
      ? 'bg-foreground text-background'
      : 'text-foreground/70 hover:bg-muted hover:text-foreground',
  );
}
